import { ContainerOwnProps } from '@mui/material';
import MContainer from '~/components/@material-extend/container';

type ContainerProps =
  | {
      children: React.ReactElement[];
    }
  | ContainerOwnProps;

function Container({ children, ...rest }: ContainerProps) {
  return (
    <MContainer maxWidth={false} {...rest}>
      {children}
    </MContainer>
  );
}

export default Container;
